<template>
  <div class="mt-3 room">
        <div class="room-Type">
                <el-form ref="formData" :model="formData" label-width="80px" :rules="rules">
                        <!-- <div class="room-title mb-3" v-if="!orderConfirm">
                            {{formData.team_type==1?'住宿询价':'会议询价'}}
                        </div>
                    <div class="room-title mb-3" v-else>
                        {{formData.team_type==1?'住宿确认':'会议确认'}}
                    </div> -->
                    <!--团队类型-->
                    <!-- <el-form-item label="团队类型" :label-width="labelWidth">
                        <el-radio-group v-model="formData.team_type" size="small">
                            <el-radio-button :label="1" v-if="ruleForm.order_type===1">旅游团</el-radio-button>
                            <el-radio-button :label="2">会议团</el-radio-button>
                        </el-radio-group>
                    </el-form-item> -->
                    <!--团号标题-->
                    <el-form-item label="团号标题"  label-width="90px">
                        <el-input v-model="formData.title" placeholder="请输入团号标题"></el-input>
                    </el-form-item>
                    <div class="quick-title mb-4">
                        <div class="ml-3">快捷选项:</div>
                        <ul class="quick-title-list">
                            <li v-for="item in (ruleForm.order_type===1?teams:teamsto)" :key="item" @click="formData.title=item">{{item}}</li>
                        </ul>
                    </div>
                    <el-form-item label="用房区域" prop="district" label-width="90px" v-if="!modify&&!isHotelInquiry">
                    <select-city class=""
                        mutiBlocks
                        :release="true"
                        :width="60"
                        :order="true"
                        @getCityInfo="getCityInfo"
                        :provinceId="formData.province"
                        :cityId="formData.city"
                        :districtIds="formData.district"/>
                    </el-form-item>
                    <!-- <div class="room-title mb-3 mt-3">
                        入住需求    
                    </div> -->
                    <!--酒店星级-->
                    <el-form-item label="酒店星级" prop="star" :label-width="labelWidth" v-if="!modify&&!isHotelInquiry">
                        <el-checkbox-group v-model="formData.star">
                        <el-checkbox :label="item.id" v-for="item in $GVAR.HotelStar.slice(2,9)" :key="item.id">{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <!--入住/离店-->
                    <el-form-item label="入住/离店" prop="date_in" :label-width="labelWidth" v-if="ruleForm.order_type===1&&!modify||ruleForm.order_type===1&&orderConfirm">
                        <el-date-picker
                            v-model="formData.date_in"
                            type="daterange"
                            value-format="timestamp"
                            range-separator="至"
                            start-placeholder="入住日期"
                            end-placeholder="离店日期"
                            :picker-options="pickerOptions"
                        />
                    </el-form-item>
                    <!--入住人数-->
                    <el-form-item label="入住人数" prop="num" :label-width="labelWidth" v-if="ruleForm.order_type===1">
                        <el-input placeholder="请输入人数"  type="number" v-model="formData.num">
                            <template slot="append">人</template>
                        </el-input>
                    </el-form-item>
                    <!--早餐需求-->
                    <el-form-item label="'早餐需求'" prop="breakfast" :label-width="labelWidth" v-if="ruleForm.order_type===1&&!modify">
                        <el-radio-group v-model="formData.breakfast">
                            <el-radio :label="item.name" v-for="item in $GVAR.breakfastTypeArr" :key="item.id">{{item.name}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="正餐类型" prop="eatery" :label-width="labelWidth" v-if="ruleForm.order_type===1&&eaterySwitch">
                        <el-radio-group v-model="formData.eatery">
                            <el-radio :label="item.id" v-for="item in $GVAR.eateryArr" :key="item.id">{{item.name}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <!--其他需求-->
                    <el-form-item label="会议设施"  :label-width="labelWidth"  v-if="meetRoomSwitch||formData.order_type==2">
                        <el-checkbox-group v-model="formData.other">
                        <el-checkbox :label="item.id" v-for="item in $GVAR.meetRoomObj" :key="item.id">{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <!--报价说明-->
                    <el-form-item label="需求备注"  :label-width="labelWidth">
                        <el-input type="textarea" v-model="formData.remark" resize="none"  :rows="4" placeholder="请输入需求备注(可选)"></el-input>
                    </el-form-item>
                    <!-- <el-form-item class="room-bottom">
                        <el-button type="primary" @click="submitForm('formData')">下一步、填写{{ruleForm.order_type===1?'用房':'会议'}}需求</el-button>
                    </el-form-item> -->
            </el-form>
       </div>
       <!--其他需求-->
       <div class="other" v-if="ruleForm.order_type===1">
            <p>更多信息</p>
            <ul class="other-list">
                <li :class="{'other-active':eaterySwitch}" @click="eaterySwitch=!eaterySwitch">正餐类型</li>
                <li :class="{'other-active':meetRoomSwitch}" @click="meetRoomSwitch=!meetRoomSwitch">会议室设施</li>
            </ul>
       </div>
  </div>
</template>

<script>
export default {
  name: 'roomBasic',
  components: {},
  props: {
    ruleForm: {
      type: Object,
      default: () => {}
    },
    //是否是修改订单
    modify: {
      type: Boolean,
      default: false
    },
    //是否询价酒店
    isHotelInquiry: {
      type: Boolean,
      default: false
    },
    //是否确认订单
    orderConfirm: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
        labelWidth: '90px',
        formData: {},
        eaterySwitch: false,                   //正餐开关
        meetRoomSwitch: false,                 //会议开关
        rules: {
            title: [
                { required: true, message: '请输入团号标题', trigger: 'blur' },
            ],
            star: [
                { type: 'array', required: true, message: '请选择酒店星级', trigger: 'change' }
            ],
            date_in: [
                { required: true, message: '请选择入住/离店时间', trigger: 'blur' },
            ],
            num: [
                { required: true, message: '请输入住人数', trigger: 'blur' },
            ],
            district: [
                { type: 'array', required: true, message: '请选择用房区域', trigger: 'change' }
            ],
            breakfast: [
                { required: true, message: '请选择早餐需求', trigger: 'blur' },
            ],
        },
        pickerOptions: {
            disabledDate(date) {
                // 禁用 今天0点之前的日期（今天可以选）
                const today = new Date()
                today.setHours(0, 0, 0, 0)
                return date < today
            }
        },
        teams: ['散客班','疗养团','老年团','亲子团','研学团','外宾团','成人团'],             //快捷标题
        teamsto: ['年会','工作会/总结会','同学会/好友聚会','答谢会','发布会/颁奖/庆典','OUTING/会奖','培训/讲座','沙龙','研讨/交流/论坛'], //快捷标题
    };
  },
  computed: {},
  watch: {
    ruleForm: {
      handler(newVal, oldVal) {
        this.formData = {...this.formData,...newVal};
      },
      deep: true,
      immediate: true // 一进页面就执行一次（可选）
    }
  },
  created() {},
  mounted() {},
  methods: {
        submitForm() {
            return new Promise(resolve => {
                this.$refs.formData.validate((valid) => {
                    console.log(this.formData.title)
                    //团号标题如果未空则生成随机标题
                    if(this.formData.title==''){
                        this.formData.title=this.getDateRandomStr();
                    }
                    resolve({isSubmit:valid,formData:this.formData});
                });
                
            })
      },
    // 生成目标格式日期随机串
    getDateRandomStr() {
        const now = new Date()
        // 年
        const year = now.getFullYear()
        // 月 
        const month = String(now.getMonth() + 1).padStart(2, '0')
        // 日 
        const day = String(now.getDate()).padStart(2, '0')
        // 0-999随机数
        const randomNum = Math.floor(Math.random() * 1000)
        // 随机数补三位
        const randomStr = String(randomNum).padStart(3, '0')
        // 拼接
        return `${year}-${month}-${day}-${randomStr}`+ (this.formData.team_type==1?'旅游团':'会议团')
    },
     //获取省市区id
      getCityInfo (info) {
        console.log(info)
        this.formData.province = info.province;
        this.formData.city = info.city;
        this.formData.district = info.district.map(v => v.id);
        // this.cityName = info;
      },
  }
};
</script>

<style lang="scss" scoped>
    .room{
        text-align: left;
    }
     .room-Type{
        background-color: #fff;
        box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
        width: 94%;
        padding: 3%;
        border-radius: 6px;
    }
    .room-title{
        font-size: 18px;
        font-weight: bold;
        color: #333;
        position: relative;
        padding-left: 12px;
        &::after{
            content: '';
            position: absolute;
            left: 0;
            top: 4px;
            height: 20px;
            width: 4px;
            background-color: var(--smtc-color-primary);
            border-radius: 50px;
        }
    }
    .quick-title{
        display: flex;
        margin-left: 80px;
        align-items: center;
        font-size: 12px;
        color:var(--smtc-color-text-shallow);
    }
    .quick-title-list{
        display:flex;
        justify-content: left;
        
        li{
            margin-left: 10px;
            cursor: pointer;
            border: 1px dashed  var(--smtc-color-text-shallow);
            padding: 4px 6px;
            border-radius: 4px;
            font-size: 12px;
            
        }
    }
    .other{
            background-color: #fff;
            box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
            width: 94%;
            padding: 2% 3%;
            display: flex;
            justify-content: left;
            margin-top: 20px;
    }
    .other p{
        display: flex;
        justify-content: center;
        flex-direction: column;
        font-size: 12px;
    }
    .other-list{
        display: flex;
        li{
            margin-left: 14px;
            border: 1px dashed #999;
            padding: 4px 10px;
            font-size: 12px;
            border-radius: 4px;
            cursor: pointer;
        }
        .other-active{
            background-color: var(--smtc-color-primary);
            color: #fff;    
            border:1px solid var(--smtc-color-primary);
        }
    }
    //  .room-bottom{
    //     display: flex;
    //     justify-content: center;
    //  }
</style>
<style>
 .room .el-input__inner{
    height: 36px;
    line-height: 36px;
 }
 .room .el-range-editor.el-input__inner{
    width: 100%;
 }
</style>